import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../shared/media-query';
class Component extends BaseComponent {
    render({ item }) {
        if (item.key == 'kc') {
            return (
                <catalog-input-item>
                    <label className={item.key}>
                        <a href='/store/karma-coins'>Karma Coins</a>
                    </label>
                </catalog-input-item>
            );
        }

        if (item.value == 'all' && (MQ.isMobile())) {
            return (
                <catalog-input-item key={item.key}>
                    <label id={item.value} className={`${item.key} ${item.checked ? 'checked' : ''}`}>
                        <input
                            type={item.key == 'divination' ? 'radio' : 'checkbox'}
                            name={item.key}
                            value={item.value}
                            checked={item.checked}
                            onChange={() => this.handleChange(item)}
                        />
                        View<br /> All
                    </label>
                </catalog-input-item>
            );
        }

        return (
            <catalog-input-item key={item.key}>
                <label id={item.value} className={`${item.key} ${item.checked ? 'checked' : ''}`}>
                    <input
                        type={item.key == 'divination' ? 'radio' : 'checkbox'}
                        name={item.key}
                        value={item.value}
                        checked={item.checked}
                        onChange={() => this.handleChange(item)}
                    />
                    {item.name}
                </label>
            </catalog-input-item>
        );
    }

    handleChange = (item) => {
        document.getElementById(item.value).classList.add('checked');
        item.checked = !item.checked;
        this.props.callback(item);
        this.props.setFilter();
    }
}

const mapDispatchToProps = (dispatch) => ({
    setFilter: () => dispatch({ type: 'catalog:set-filter' }),
});

export default connect(null, mapDispatchToProps)(Component);
